export default __webpack_public_path__ + "static/media/progress.446449d0.svg";